export const dashboardMap = {
  "Hitachi Overall Dashboard": "DASHBOARD-ORGANIZATION",
  "Sector Dashboard": "DASHBOARD-SECTOR",
  "Business Unit Dashboard": "DASHBOARD-BU",
  "Sub Business Unit Dashboard": "DASHBOARD-SUBBU",
  "Entity Dashboard": "DASHBOARD-LEGALENTITY",
  "Region Dashboard": "DASHBOARD-REGION",
  "Country Dashboard": "DASHBOARD-COUNTRY"
};

export const adminSubMenus = [
  {
    path: "/admin/self-verification/levelmanagement",
    page: "Level Management",
    translationKey: "levelManagement",
  },
  {
    path: "/admin/self-verification/slotmanagement",
    page: "Slot Management",
    translationKey: "slotManagement",
  },
  {
    path: "/admin/self-verification/templatemanagement",
    page: "Template Management",
    translationKey: "templateManagement",
  },
  {
    path: "/admin/self-verification/assessment",
    page: "Assessment Management",
    translationKey: "assessmentManagement",
  },
];

export const DMS_ACTIONS = [
  { key: "publishWithWorkflow", translationKey: "publishWithWorkflow" },
  { key: "publishWithoutWorkflow", translationKey: "publishWithoutWorkflow" },
  { key: "reviseDocument", translationKey: "reviseDocument" },
  { key: "deactivateDocument", translationKey: "deactivateDocument" },
  { key: "documentHistory", translationKey: "documentHistory" },
];

export const foundationMenus = [
  { path: "/admin/foundation/administrator-management", label: "Administrator Management", translationKey: "administratorManagement" },
  { path: "/admin/foundation/organization-management", label: "Organization Management", translationKey: "organizationManagement" },
  { path: "/admin/foundation/group-management", label: "Distribution List Management", translationKey: "distributionListManagement" },
  { path: "/admin/foundation/picmanagement", label: "PIC Management", translationKey: "picManagement" },
  { path: "/admin/foundation/rcmmanagement", label: "RCM Management", translationKey: "rcmManagement" },
  { path: "/admin/foundation/external-user-management", label: "External User Management", translationKey: "externalUserManagement" },
  { path: "/admin/foundation/domain-management", label: "Domain Management", translationKey: "domainManagement" },
];

export const dashboardKeyMap = {
    "Hitachi Overall Dashboard": "hitachiDashboard",
    "Sector Dashboard": "sectorDashboard",
    "Business Unit Dashboard": "businessUnitDashboard",
    "Sub Business Unit Dashboard": "subBusinessUnitDashboard",
    "Entity Dashboard": "entityDashboard",
    "Region Dashboard": "regionDashboard",
    "Country Dashboard": "countryDashboard",
    // Add more as needed
};

export const filterKeyMap = {
        Slot: "slot",
        Template: "template",
        Sector: "sector",
        Region: "region",
        Country: "country",
        "Business Unit": "businessUnit",
        "Sub BU": "subBu",
        Entity: "entity",
};

export const labelKeyMap = {
    Basic: "basic",
    Developing: "developing",
    Mature: "mature",
    Aggregate: "aggregate"
};